let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jw9Zj")).then(() => parcelRequire('4xnvv'));